import {
  useAddTenantEnumOptionMutation,
  useRemoveTenantEnumOptionMutation,
  useRenameTenantEnumOptionMutation,
  useSetTenantEnumPriorityMutation,
  useToggleTenantEnumOptionMutation,
} from '@dms/api/settings';
import {handleApiError} from '@dms/shared';

export const useUpdateEnum = (definitionId: string, resourceId: string) => {
  const [removeTenantEnumOption, {isLoading: isRemoving}] = useRemoveTenantEnumOptionMutation();
  const [renameTenantEnumOption, {isLoading: isRenaming}] = useRenameTenantEnumOptionMutation();
  const [addTenantEnumOption, {isLoading: isAdding}] = useAddTenantEnumOptionMutation();
  const [toggleTenantEnumOption, {isLoading: isToggling}] = useToggleTenantEnumOptionMutation();
  const [setTenantEnumPriority, {isLoading: isSettingPriority}] =
    useSetTenantEnumPriorityMutation();

  const isLoading = isRemoving || isRenaming || isToggling || isSettingPriority || isAdding;

  const updateName = (enumOptionId: string, name: string) => {
    renameTenantEnumOption({
      definitionId,
      enumOptionId,
      resourceId,
      renameEnumOptionRequestBody: {name},
    })
      .unwrap()
      .catch(handleApiError);
  };

  const updatePriority = (enumOptionIds: string[]) => {
    setTenantEnumPriority({
      definitionId,
      resourceId,
      setEnumPriorityRequestBody: {
        options: enumOptionIds.map((id, index) => ({uuid: id, priority: index + 1})),
      },
    })
      .unwrap()
      .catch(handleApiError);
  };

  const updateActive = (enumOptionId: string, active: boolean) => {
    toggleTenantEnumOption({
      definitionId,
      enumOptionId,
      resourceId,
      toggleEnumOptionRequestBody: {active},
    })
      .unwrap()
      .catch(handleApiError);
  };

  const remove = (enumOptionId: string) => {
    removeTenantEnumOption({
      definitionId,
      enumOptionId,
      resourceId,
    })
      .unwrap()
      .catch(handleApiError);
  };

  const add = (name: string, priority: number) => {
    addTenantEnumOption({
      definitionId,
      resourceId,
      addEnumOptionRequestBody: {name, priority},
    })
      .unwrap()
      .catch(handleApiError);
  };

  return {updateName, updatePriority, updateActive, remove, add, isLoading};
};
